import { z } from "zod";

//QualidadeIndicadoresSchema

const optionalString = z.string().nullable().optional();

export const QualidadeIndicadoresSchema = z.object({
    IdIndicador: z.number().nullable().optional(), 
    Item: z.string(),
    Descricao: optionalString,
    Ativo: z.number().nullable().optional(), 
    Indice: optionalString,
    Frequencia: optionalString,
    Meta: optionalString,
    Resultado: optionalString,
});

// QualidadeIndicadoresForm

export type QualidadeIndicadoresForm = z.infer<typeof QualidadeIndicadoresSchema>;